import "../PageNotFound/PageNotFound.css";
export const PageNotFound = () => {
  return (
    <>
      <div className="center">
        <img
          src="https://cdn.dribbble.com/users/812639/screenshots/12077521/j_0284_01_1x.jpg"
          alt="page-not-found"
        />
      </div>
      <h1 className="page-not-found-title">Page Not Found</h1>
    </>
  );
};
